module.exports = __webpack_public_path__ + "static/media/screen-inventory.a25758ad.png";